import React, { Component } from "react";
import Header from "../components/common/Header";
import SideBar from "../components/common/SideBar";
import { getMyExam } from "../services/ExamService";
import ExamInProgress from "../components/exam/ExamInProgress";
import ExamCompleted from "../components/exam/ExamCompleted";
import { ContentWrapper } from "../components/common/GlobalElements/Wrappers";
import PageHeader from "../components/common/GlobalElements/PageHeader";

class ExamSummeryPage extends React.Component {
  render() {
    return (
      <>
        <Header></Header>
        <ContentWrapper>
          <SideBar></SideBar>
          <div className="sidebar-right">
            <div className="exam-list-wrap">
              <PageHeader title={<>My <span>Exam Registrations</span></>} />

              <ExamInProgress />
              <ExamCompleted />
            </div>
          </div>
        </ContentWrapper>
      </>
    );
  }
}

export default ExamSummeryPage;
